(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5234],{

/***/ 59985:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sponsors",
      function () {
        return __webpack_require__(24824);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var babel_plugin_superjson_next_tools__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23544);
/* harmony import */ var babel_plugin_superjson_next_tools__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(babel_plugin_superjson_next_tools__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_Layout_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4828);
/* harmony import */ var _utils_classNames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43153);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);





function Home(param) {
    let { jobPosts , totalHits , nextCursor , jobPostSearchParams  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout_Layout__WEBPACK_IMPORTED_MODULE_2__/* .Layout */ .A, {
        pageTitle: "Sponsors",
        hasSearch: true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,_utils_classNames__WEBPACK_IMPORTED_MODULE_4__/* .classNames */ .A)("px-4 text-center"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "text-5xl tracking-tight font-black text-black sm:text-6xl md:text-7xl",
                        children: "Sponsors"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "mt-6 text-xl tracking-tight font-semiboldX text-black sm:mt-8 sm:text-3xl md:mt-10 md:text-xl",
                        children: [
                            "We are open for our first sponsorships. ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "Help support the JavaScript community by becoming a sponsor. ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-lg",
                                children: "\uD83D\uDC69‍\uD83D\uDCBB\uD83D\uDC69\uD83C\uDFFB‍\uD83D\uDCBB\uD83D\uDC69\uD83C\uDFFC‍\uD83D\uDCBB\uD83D\uDC69\uD83C\uDFFD‍\uD83D\uDCBB\uD83D\uDC69\uD83C\uDFFE‍\uD83D\uDCBB\uD83D\uDC69\uD83C\uDFFF‍\uD83D\uDCBB\uD83E\uDDD1‍\uD83D\uDCBB\uD83E\uDDD1\uD83C\uDFFB‍\uD83D\uDCBB\uD83E\uDDD1\uD83C\uDFFC‍\uD83D\uDCBB\uD83E\uDDD1\uD83C\uDFFD‍\uD83D\uDCBB\uD83E\uDDD1\uD83C\uDFFE‍\uD83D\uDCBB\uD83E\uDDD1\uD83C\uDFFF‍\uD83D\uDCBB\uD83D\uDC68‍\uD83D\uDCBB\uD83D\uDC68\uD83C\uDFFB‍\uD83D\uDCBB\uD83D\uDC68\uD83C\uDFFC‍\uD83D\uDCBB\uD83D\uDC68\uD83C\uDFFD‍\uD83D\uDCBB\uD83D\uDC68\uD83C\uDFFE‍\uD83D\uDCBB\uD83D\uDC68\uD83C\uDFFF‍\uD83D\uDCBB"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "max-w-4xl m-auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-20 text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        className: "p-8 font-bold border bg-gray-100 text-blue-600 rounded-lg hover:bg-gray-200",
                        href: "https://github.com/sponsors/JobsinJS",
                        children: "Be the first sponsor!"
                    })
                })
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,babel_plugin_superjson_next_tools__WEBPACK_IMPORTED_MODULE_1__.withSuperJSONPage)(Home));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,8184,3544,4828,9774,2888,179], function() { return __webpack_exec__(59985); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);